const wrapper_class = 'accordion-wrapper',
    action_class = '.accordion-action',
    content_class = '.accordion-slideable',
    chevron_class = '.accordion-chevron',
    slide_up_class = 'slide-up',
    slide_down_class = 'slide-down',
    rotate_class = 'rotate-180',
    rotate_back_class = 'rotate-180-back',
    initial_blocker_class = 'd-none'

module.exports = () => {
    for (const wrapper_element of document.getElementsByClassName(wrapper_class)) {

        const action_node = wrapper_element.querySelectorAll(action_class)?.[0],
            content_node = wrapper_element.querySelectorAll(content_class)?.[0],
            chevron_node = wrapper_element.querySelectorAll(chevron_class)?.[0]

        if (action_node && content_node) {
            action_node.addEventListener(
                'click',
                () => {
                    content_node.classList.contains(initial_blocker_class)
                    && content_node.classList.remove(initial_blocker_class)

                    content_node.classList.toggle(slide_up_class)
                    content_node.classList.toggle(slide_down_class)
                    chevron_node?.classList?.toggle(rotate_class)
                    chevron_node?.classList?.toggle(rotate_back_class)
                }
            )
        }
    }
}
